<script setup lang="ts">
import ContentLayout from "@/components/ContentLayout/ContentLayout.vue";
import {
    LuvHeadline,
    LuvText,
    LuvLink
} from "@polargold/luv-ui-library";
import { ROUTE } from "@/router/routeDefinitions.ts";
import { useI18n } from "vue-i18n";
import { useRouterPush } from "@/composable/useRouterPush";
import { useRouterGo } from "@polargold/pg-frontend-vue";
import ErrorPage from "@/components/ErrorPage/ErrorPage.vue";

const { t } = useI18n();
const { routerPush } = useRouterPush();
const { routerGo } = useRouterGo();

const goBack = () => {
    routerGo(-1);
};

const goHome = async () => {
    await routerPush({ name: ROUTE.RESTRICTED_AREA.NAME });
};

</script>

<template>
    <ContentLayout>
        <ErrorPage>
            <template #headline>
                <LuvHeadline headline-size="h3">
                    {{ t("VIEWS.ERROR_PAGE.TITLE") }}
                </LuvHeadline>
            </template>

            <template #subHeadline>
                <LuvText>
                    {{ t("VIEWS.ERROR_PAGE.TEXT") }}
                </LuvText>
            </template>

            <template #action>
                <ul>
                    <li class="font-bold mb-text-sm" @click="goHome">
                        <LuvLink @click.prevent="goHome" class="font-bold">
                            {{ t("VIEWS.ERROR_PAGE.LINK.GO_HOME") }}
                        </LuvLink>
                    </li>

                    <li class="font-bold mb-text-sm" @click="goBack">
                        <LuvLink @click.prevent="goBack" class="font-bold">
                            {{ t("VIEWS.ERROR_PAGE.LINK.GO_BACK") }}
                        </LuvLink>

                    </li>

                    <li class="font-bold mb-text-sm">
                        <LuvLink
                            href="mailto:support@polargold.de"
                            class="font-bold"
                        >
                            {{ t("VIEWS.ERROR_PAGE.LINK.CONTACT") }}
                        </LuvLink>
                    </li>
                </ul>
            </template>
        </ErrorPage>

    </ContentLayout>
</template>
